/**
 * Validator error key -> i18n key. Same map the legacy tilby-magic-form used (`defaultErrors`),
 * so migrated forms show identical messages.
 */
export const FIELD_ERROR_MESSAGES: Readonly<Record<string, string>> = {
    min: 'NG_MESSAGES.NUMBER_NOT_VALID',
    max: 'NG_MESSAGES.NUMBER_NOT_VALID',
    required: 'NG_MESSAGES.REQUIRED_FIELD',
    email: 'NG_MESSAGES.INVALID_VALUE',
    minlength: 'NG_MESSAGES.NAME_TOO_SHORT',
    maxlength: 'NG_MESSAGES.NAME_TOO_LONG',
    pattern: 'NG_MESSAGES.INVALID_VALUE',
    matchRequired: 'NG_MESSAGES.INVALID_VALUE',
};

/** Returns the i18n key of the first known error of `errors`, in map order, or null. */
export function firstErrorMessageKey(
    errors: Record<string, unknown> | null | undefined,
    messages: Readonly<Record<string, string>> = FIELD_ERROR_MESSAGES
): string | null {
    if (!errors) {
        return null;
    }
    const key = Object.keys(messages).find(k => k in errors);
    return key ? messages[key] : null;
}
